'use client';

import React from "react";
import { Button, Grid, Item } from "semantic-ui-react";
import { VscChromeClose } from "react-icons/vsc";
import Link from "next/link";
import MapWrapper from './MapWrapper';

class Map extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lat: "",
      lng: "",
      showmarkers: "false",
      mapheight: 250,
      isFullView: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.poly_data !== this.state.polyGon) {
      this.setState({
        polyGon: nextProps.poly_data,
      });
    }

    const passDataLat = nextProps.lat;
    const passDataLng = nextProps.lng;
    const passShowmarkers = nextProps.showmarkers;

    if (this.state.lat !== passDataLat) {
      this.setState({
        lat: passDataLat,
        lng: passDataLng,
        showmarkers: passShowmarkers,
      });
    }
  }

  componentDidMount() {
    const passDataLat = this.props.lat;
    const passDataLng = this.props.lng;
    const passShowmarkers = this.props.showmarkers;
    const passPolyData = this.props.poly_data;

    this.setState({
      lat: passDataLat,
      lng: passDataLng,
      showmarkers: passShowmarkers,
      polyGon: passPolyData,
    });
  }

  setIsFullView = (value) => {
    this.setState({ isFullView: value });
  };

  handleClick = () => {};

  render() {
    const { isFullView } = this.state;

    if (isFullView) {
      return (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'white',
          zIndex: 9999,
          display: 'flex',
          flexDirection: 'column'
        }}>
          <div style={{
            padding: '10px',
            textAlign: 'right',
            borderBottom: '1px solid #ddd'
          }}>
            <Button icon onClick={() => this.setIsFullView(false)}>
              <VscChromeClose size={24} />
            </Button>
          </div>
          <div style={{ flex: 1 }}>
            <MapWrapper
              poly_data={this.state.polyGon}
              nhdetails={this.props.nhdetails}
              showmarkers={this.state.showmarkers}
              npiscore={this.props.npiscore}
              npirank={this.props.npirank}
              nhname={this.props.nhname}
              lat={this.state.lat || this.props.lat}
              lng={this.state.lng || this.props.lng}
              homes={this.props.homes}
              mapheight="100%"
            />
          </div>
        </div>
      );
    }

    return (
      <div style={{ position: "relative" }}>
        <Grid>
          <Grid.Row style={{ padding: 0 }}>
            <Grid.Column id="map">
              <div
                style={{
                  padding: "13px 0px 13px 0px",
                  margin: "10px 0px",
                  position: "relative",
                }}
              >
                <MapWrapper
                  poly_data={this.state.polyGon}
                  nhdetails={this.props.nhdetails}
                  showmarkers={this.state.showmarkers}
                  npiscore={this.props.npiscore}
                  npirank={this.props.npirank}
                  nhname={this.props.nhname}
                  lat={this.state.lat || this.props.lat}
                  lng={this.state.lng || this.props.lng}
                  homes={this.props.homes}
                  mapheight={this.state.mapheight}
                />
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

export default Map;